__turbopack_context__.v({
  "button": "Button-module-scss-module__gW1A4G__button",
});
